import Swiper from "swiper";
import {Navigation} from "swiper/modules";

export function testimonials(){
    for(let testimonials of document.querySelectorAll('.testimonials')){
        const swiper = new Swiper(testimonials, {
            modules: [Navigation],
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}